import React from 'react'
import { Card, CardBody } from 'reactstrap'
import CustomDataTable from '../../../Components/CustomTable/CustomTable'
import { Triangle } from 'react-loader-spinner';




const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const CreditLogs = ({creditLogs,loading}) => {

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => `${row.firstName} ${row.lastName}`,
      cell: (row) => (
        <Link to={`/customer/${row?.id}`}>
          {row.firstName} {row.lastName}
        </Link>
      ),
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Phone No",
      selector: (row) => row.phoneNo,
      sortable: true,
    },
    {
      name: "Customer Type",
      selector: (row) => row.customerTypeName,
      sortable: true,
    },
    {
      name: "Discount (%)",
      selector: (row) => row.customerTypeDiscount,
      sortable: true,
      right: true,
    },

    // {
    //   name: "Action",
    //   selector: (row) => (
    //     <div>
    //       <Button
    //         color="btn btn-soft-warning"
    //         className="btn-sm ms-1"
    //         onClick={() => {
    //           setAddModal(true);
    //           setSelectedCustomer(row);
    //         }}
    //       >
    //         <i className="ri-edit-line" />
    //       </Button>
    //       <Button
    //         className="btn btn-soft-danger btn-sm ms-1"
    //         color="danger"
    //         onClick={() => handleDeleteClick(row.id)}
    //       >
    //         <i className="ri-delete-bin-5-line" />
    //       </Button>
    //     </div>
    //   ),
    //   center: true,
    // },
  ];


  return (
    <div>
        <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={creditLogs}
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default CreditLogs